import { render, staticRenderFns } from "./complaint-register-page.vue?vue&type=template&id=415c95be&scoped=true"
import script from "./complaint-register-page.vue?vue&type=script&lang=js"
export * from "./complaint-register-page.vue?vue&type=script&lang=js"
import style0 from "./complaint-register.scss?vue&type=style&index=0&id=415c95be&prod&scoped=true&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c95be",
  null
  
)

export default component.exports